import React from 'react';
import CareerGuidance2025 from 'views/CareerGuidance2025';


const BridgeCoursePage = () => {
  return <CareerGuidance2025/>;
};

export default BridgeCoursePage;